module.exports = __webpack_public_path__ + "img/yuq2.ff36e00b.jpg";